// src/pages/LoginPage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import logo from "../logo.png"; // your logo

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const sendOtp = async () => {
    if (!email) {
      setError("Please enter a valid email.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/api/employee/otp/send", { email });
      navigate("/verify", { state: { email } });
    } catch (err) {
      setError(err.response?.data?.message || "Failed to send OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <img src={logo} alt="Logo" className="header-logo" />
      <h2>Login</h2>

      <div className="form-group">
        <input
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <button onClick={sendOtp} disabled={loading}>
        {loading ? "Sending…" : "Send OTP"}
      </button>

      {error && <p className="error-message">{error}</p>}
    </div>
  );
}
